<div class="video-heroes">
  <div class="video-heroes__header">
    <div class="video-heroes__title-section">
      <div class="video-heroes__title">
        {{ 'app.components.courseCreator.settings.videoHeroes.title' | translate }}
      </div>
    </div>
  </div>

  <div class="video-heroes__content">
    <div class="video-heroes__section">
      <div class="video-heroes__section-label">
        {{ 'app.components.courseCreator.settings.videoHeroes.mainHero' | translate }}
      </div>
      <div class="video-heroes__list" role="radiogroup">
        @for (preset of presets; track preset.name) {
          <label class="video-heroes__row">
            <input
              type="radio"
              class="video-heroes__radio"
              name="video-main-hero"
              [value]="preset.name"
              [checked]="isMain(preset.name)"
              (change)="selectMain(preset.name)"
            />
            <img
              class="video-heroes__thumb"
              [src]="preset.imageUrl"
              [alt]="preset.name"
              width="28"
              height="28"
            />
            <span class="video-heroes__name">{{ preset.name }}</span>
          </label>
        }
      </div>
    </div>

    <div class="video-heroes__section">
      <div class="video-heroes__section-label">
        {{ 'app.components.courseCreator.settings.videoHeroes.backgroundHeroes' | translate }}
      </div>
      <div class="video-heroes__list">
        @for (preset of presets; track preset.name) {
          <label
            class="video-heroes__row"
            [class.video-heroes__row--disabled]="isMain(preset.name)"
          >
            <input
              type="checkbox"
              class="video-heroes__checkbox"
              [checked]="isBackgroundChecked(preset.name)"
              [disabled]="isMain(preset.name)"
              (change)="toggleBackground(preset.name)"
            />
            <img
              class="video-heroes__thumb"
              [src]="preset.imageUrl"
              [alt]="preset.name"
              width="28"
              height="28"
            />
            <span class="video-heroes__name">{{ preset.name }}</span>
          </label>
        }
      </div>
    </div>
  </div>
</div>
